import { StrictMode } from "react";

import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import "@/config/i18n";

import App from "@/App";
import { Config } from "@/config/Config";

// Without VITE_SENTRY_DSN the SDK stays disabled (local dev).
Sentry.init({
	dsn: Config.sentry_dsn,
	environment: Config.sentry_environment,
	release: Config.app_version,
});

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>
);
